export interface ConditionParams {
    ItemID: number,
    JavaScriptOperator: string
    ItemValue: string|Map<number, string>,
}

import ratingSlider from "./_rating-slider";

class SamePage {

    hasValue($element: JQuery): boolean {
        if ($element.is(':radio') || $element.is(':checkbox')) {
            return $element.prop('checked');
        }
        return (<string>$element.val()).length > 0;
    };

    resetInputField($element: JQuery): void {
        $element.find($("input:text, input[type='number'], textarea")).val('');
        $element.find($('input:radio')).prop('checked', false);
        $element.find('select').find('option').prop('selected', false);

        // rating sliders elements
        const $bootstrapSliders = $('.rating-slider .bootstrap-slider', $element);
        $bootstrapSliders.each(function () {
            ratingSlider.resetRatingSliderInput($(this));
        });
        // re-initialize rating sliders
        if ($bootstrapSliders.length) {
            ratingSlider.initOnce(true);
        }
    };

    showTargetElement($element: JQuery): void {
        $element.show();
        $('.survey-element', $element).trigger('show'); // Trigger show event
        this.markConditionLabel($element, true);
        // Remove itemIDs from hidden-client-side-skipped-item-ids element
        let skippedItemIds = this.getSkippedItemIds();
        $element.find($('input, textarea')).each(function () {
            const itemID = $(this).data('item-id').toString();
            if (skippedItemIds.indexOf(itemID) >= 0) {
                // Remove itemID
                skippedItemIds = skippedItemIds.filter(function (value) {
                    return value !== itemID;
                })
            }
        });
        $('input[name="hidden-client-side-skipped-item-ids"]').val(skippedItemIds.join(';'));
    };

    hideTargetElement($element: JQuery): void {
        $element.hide();
        $('.survey-element', $element).trigger('hide');  // Trigger hide event
        this.markConditionLabel($element, false);
        // Add itemIDs to hidden-client-side-skipped-item-ids element
        const skippedItemIds = this.getSkippedItemIds();
        $('input, textarea', $element).each(function () {
            const itemID = $(this).data('item-id').toString();
            if (!(skippedItemIds.indexOf(itemID) >= 0)) {
                skippedItemIds.push(itemID);
            }
        });
        $('input[name="hidden-client-side-skipped-item-ids"]').val(skippedItemIds.join(';'));
    };

    markConditionLabel($element: JQuery, isConditionTrue: boolean): void {
        const $skipConditionLabel = $element.prev().find($('.skip-condition-label'));
        if ($skipConditionLabel.length > 0) {
            // Change color of condition label
            $skipConditionLabel.removeClass(isConditionTrue ? 'bg-danger' : 'bg-success');
            $skipConditionLabel.addClass(isConditionTrue ? 'bg-success' : 'bg-danger');
            // Change skip hint inside popover
            const $popoverContent = $('<div>' + $skipConditionLabel.data('bs-content') + '</div>');
            const $conditionFalseHint = $('.hint-false', $popoverContent);
            const $conditionTrueHint = $('.hint-true', $popoverContent);
            if (isConditionTrue) {
                $conditionTrueHint.removeClass('visually-hidden');
                $conditionFalseHint.addClass('visually-hidden');
            } else {
                $conditionFalseHint.removeClass('visually-hidden');
                $conditionTrueHint.addClass('visually-hidden');
            }
            $skipConditionLabel.attr('data-bs-content', $popoverContent.html());
        }
    };

    getElementsByItemID(itemID: number): JQuery {
        return $("[name='item-id-" + itemID + "']");
    };

    /**
     * This function translates the specified condition (specified in the survey_skip_conditions table) to JavaScript.
     * The various operators that are supported are specified in the JavaScriptOperator PHP class.
     *
     * This implementation is used instead of dynimically create a JavaScript function with 'new Function(...)'
     * because this would require the Content Security Policy header to globally allow for 'unsafe-eval'.
     */
    conditionFunction(conditionParams: ConditionParams, val: string): boolean {
        const conditionOperator = conditionParams.JavaScriptOperator;
        const conditionVal = conditionParams.ItemValue;
        if (conditionOperator === '==') {
            return val === conditionVal;
        }
        if (conditionOperator === '!=') {
            return val !== conditionVal;
        }
        if (conditionOperator === '>') {
            return val > conditionVal;
        }
        if (conditionOperator === '>=') {
            return val >= conditionVal;
        }
        if (conditionOperator === '<') {
            return val < conditionVal;
        }
        if (conditionOperator === '<=') {
            return val <= conditionVal;
        }
        if (conditionOperator === 'IN') {
            return Object.values(conditionVal).includes(val);
        }
        if (conditionOperator === 'NOT_IN') {
            return !Object.values(conditionVal).includes(val);
        }
        return false;
    };

    getSkippedItemIds(): string[] {
        const $skippedItemIdsElement = $('input[name="hidden-client-side-skipped-item-ids"]');
        const skippedItemIdsString = <string>$skippedItemIdsElement.val();
        return skippedItemIdsString === '' ? [] : skippedItemIdsString.indexOf(';') > 0 ? skippedItemIdsString.split(';') : [skippedItemIdsString];
    }

}

export default new SamePage();